import { Strings } from "src/modules/utils/shared/strings";

export class CourseParticipantDto {
    constructor(public pupilId: number, public courseId: number, public courseName: string, public courseNameForCertificate: string, public forCertificate: boolean) {
    }

    getNameForCertificate(): string {
        return Strings.def(this.courseNameForCertificate, this.courseName);
    }
}